"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaOptionsToJSON = exports.RosettaOptionsFromJSONTyped = exports.RosettaOptionsFromJSON = void 0;
const runtime_1 = require("../runtime");
function RosettaOptionsFromJSON(json) {
    return RosettaOptionsFromJSONTyped(json, false);
}
exports.RosettaOptionsFromJSON = RosettaOptionsFromJSON;
function RosettaOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sender_address': !runtime_1.exists(json, 'sender_address') ? undefined : json['sender_address'],
        'type': !runtime_1.exists(json, 'type') ? undefined : json['type'],
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
        'token_transfer_recipient_address': !runtime_1.exists(json, 'token_transfer_recipient_address') ? undefined : json['token_transfer_recipient_address'],
        'amount': !runtime_1.exists(json, 'amount') ? undefined : json['amount'],
        'symbol': !runtime_1.exists(json, 'symbol') ? undefined : json['symbol'],
        'decimals': !runtime_1.exists(json, 'decimals') ? undefined : json['decimals'],
        'gas_limit': !runtime_1.exists(json, 'gas_limit') ? undefined : json['gas_limit'],
        'gas_price': !runtime_1.exists(json, 'gas_price') ? undefined : json['gas_price'],
        'suggested_fee_multiplier': !runtime_1.exists(json, 'suggested_fee_multiplier') ? undefined : json['suggested_fee_multiplier'],
        'max_fee': !runtime_1.exists(json, 'max_fee') ? undefined : json['max_fee'],
        'fee': !runtime_1.exists(json, 'fee') ? undefined : json['fee'],
        'size': !runtime_1.exists(json, 'size') ? undefined : json['size'],
        'memo': !runtime_1.exists(json, 'memo') ? undefined : json['memo'],
        'number_of_cycles': !runtime_1.exists(json, 'number_of_cycles') ? undefined : json['number_of_cycles'],
        'contract_address': !runtime_1.exists(json, 'contract_address') ? undefined : json['contract_address'],
        'contract_name': !runtime_1.exists(json, 'contract_name') ? undefined : json['contract_name'],
        'burn_block_height': !runtime_1.exists(json, 'burn_block_height') ? undefined : json['burn_block_height'],
        'delegate_to': !runtime_1.exists(json, 'delegate_to') ? undefined : json['delegate_to'],
        'pox_addr': !runtime_1.exists(json, 'pox_addr') ? undefined : json['pox_addr'],
    };
}
exports.RosettaOptionsFromJSONTyped = RosettaOptionsFromJSONTyped;
function RosettaOptionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sender_address': value.sender_address,
        'type': value.type,
        'status': value.status,
        'token_transfer_recipient_address': value.token_transfer_recipient_address,
        'amount': value.amount,
        'symbol': value.symbol,
        'decimals': value.decimals,
        'gas_limit': value.gas_limit,
        'gas_price': value.gas_price,
        'suggested_fee_multiplier': value.suggested_fee_multiplier,
        'max_fee': value.max_fee,
        'fee': value.fee,
        'size': value.size,
        'memo': value.memo,
        'number_of_cycles': value.number_of_cycles,
        'contract_address': value.contract_address,
        'contract_name': value.contract_name,
        'burn_block_height': value.burn_block_height,
        'delegate_to': value.delegate_to,
        'pox_addr': value.pox_addr,
    };
}
exports.RosettaOptionsToJSON = RosettaOptionsToJSON;
//# sourceMappingURL=RosettaOptions.js.map